
const config = {
  id: 'professional',
  name: 'Professional',
  icon: 'user-tie',
  color: 'blue',
  welcomeMessage: "Hello! I'm your professional assistant. How can I help you today?",
  typography: "'Inter', sans-serif",
  description: 'A clean and modern visual style.',
  preview: 'I understand your request and will assist you accordingly.',
  suggestedPrompts: [
    { text: 'Tell me about your services' },
    { text: 'What are your business hours?' },
    { text: 'How can I contact support?' },
  ],
  animation: {
    messageIn: 'pro-message',
    messageOut: 'slide-out',
    typing: 'pro-typing',
    avatar: 'pro-avatar-pulse',
    button: 'pro-button-hover'
  },
  transitions: {
    duration: '0.3s',
    timing: 'ease',
    hover: '0.2s ease-in-out'
  },
  effects: {
    shadow: 'lg',
    hover: 'translateY(-2px)',
    focus: 'ring-2 ring-blue-500',
    active: 'scale-95'
  },
  embedCode: `<script src="chatbot-loader.js"></script>
<script>
window.chatConfig = {
  theme: "professional",
  color: "#3B82F6",
  typography: "Inter, sans-serif",
  welcomeMessage: "Hello! I'm your professional assistant.",
  userId: "user_prof_123",
  chatbotId: "bot_prof_001",
  animations: {
    enabled: true,
    duration: "0.3s"
  }
};
</script>`
};

export default config; 